import { BaseApi } from './base.api.js';

export class ReferenceDataApi extends BaseApi {
    constructor(client) {
        super(client, '/reference-data');
    }

    async getAll(params = {}, headers = {}) {
        const config = { params };
        if (Object.keys(headers).length > 0) {
            config.headers = headers;
        }
        const response = await this.client.get(this.basePath, config);
        const etag = response.headers?.etag || response.headers?.['etag'] || null;
        return { ...response.data, _etag: etag };
    }

    async seed({ entity, limit = 50 } = {}) {
        const response = await this.client.get(`${this.basePath}/seed`, {
            params: { entity, limit },
        });
        return response.data;
    }

    async suggest({ entity, q = '', limit = 50 } = {}) {
        const response = await this.client.get(`${this.basePath}/suggest`, {
            params: { entity, q, limit },
        });
        return response.data;
    }

    async resolve({ entity, ids = [] } = {}) {
        const response = await this.client.post(`${this.basePath}/resolve`, {
            entity,
            ids,
        });
        return response.data;
    }

    async getRegistry() {
        const response = await this.client.get(`${this.basePath}/registry`);
        return response.data;
    }
}
